import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetCloseDealersSellerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.getCloseDealersRequestFactory
   * @param {Service} deps.getInstantOfferByAdSellerService
   * @param {Function} deps.instantOfferEntityFactory
   * @param {Function} deps.invalidRequestErrorFactory
   * @param {HTTPSellerRepository} deps.repository
   */
  constructor({
    getCloseDealersRequestFactory,
    getInstantOfferByAdSellerService,
    instantOfferEntityFactory,
    invalidRequestErrorFactory,
    repository
  }) {
    super()

    this._getCloseDealersRequestFactory = getCloseDealersRequestFactory
    this._getInstantOfferByAdSellerService = getInstantOfferByAdSellerService
    this._instantOfferEntityFactory = instantOfferEntityFactory
    this._invalidRequestErrorFactory = invalidRequestErrorFactory
    this._repository = repository
  }

  /**
   * @param {Object} params
   * @param {Number} params.adId - Ad ID (alternative to instantOfferId, will fetch instantOfferId internally)
   * @param {String} params.instantOfferId - Instant Offer ID
   * @param {Boolean} params.isNextAppointment
   * @return {Promise}
   */
  @tracer({metric: 'GetCloseDealersSellerUseCase#execute'})
  @inlineError
  async execute({adId, instantOfferId, isNextAppointment = false} = {}) {
    if (!instantOfferId && !adId) return Promise.reject(this._invalidRequestErrorFactory())

    if (!instantOfferId && adId) {
      const [error, instantOfferEntity] = await this._getInstantOfferByAdSellerService.execute({adId})
      if (error) return Promise.reject(error)
      instantOfferId = instantOfferEntity.getId()
    }

    const instantOfferEntity = this._instantOfferEntityFactory({
      instantOfferId
    })

    const getCloseDealersRequest = this._getCloseDealersRequestFactory({
      instantOfferEntity,
      isNextAppointment
    })

    return this._repository
      .getCloseDealers({
        getCloseDealersRequest
      })
      .then(([error, closeDealersVO]) =>
        error ? Promise.reject(error) : closeDealersVO.toJSON().closeDealerScheduleList
      )
  }
}
